import { useTranslation } from 'react-i18next'

const Forbidden = () => {
  const { t } = useTranslation()

  return (
    <div className="content-grid container-fluid not-found" data-testid="forbidden_page">
      <div className="row parent-headband">
        <div className="col-sm-12">
          <h3>{t('noAccess')}</h3>
        </div>
      </div>
    </div>
  )
}

export default Forbidden
